(function () {
	'use strict';
	$(document).ready(function () {

		$('#form-job-offers-filter select[name=miejsce-pracy], #form-job-offers-filter input[name=typ-umowy]').on('change', function() {
			$('#form-job-offers-filter').submit();
		});

		$('#form-files-filter select').on('change', function() {
			$('#form-files-filter').submit();
		});

		const bigNumbersImageSwiper = document.querySelectorAll('.swiper-big-numbers-image');
		bigNumbersImageSwiper.forEach(function (slider) {
			new Swiper(slider, {
				loop: false,
				spaceBetween: 20,
				slidesPerView: 1,
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
			})
		});

		const bigNumbersSwiper = document.querySelectorAll('.swiper-big-numbers');
		bigNumbersSwiper.forEach(function (slider) {
			new Swiper(slider, {
				loop: false,
				spaceBetween: 20,
				slidesPerView: 1,
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				breakpoints: {
					768: {
						slidesPerView: 3,
					},
					576: {
						slidesPerView: 2,
					},
				}
			})
		});

		$('.person .js-person-more').on('click', function(e) {
			e.preventDefault();
			var $personContent = $(this).closest('.person').clone();
			$personContent.appendTo( $('.person-modal .modal-body') );
			$('.person-modal .modal-body').find('a.person-more').remove();
			$('.person-modal .person-desc').mCustomScrollbar({
				mouseWheel: {
					axis: 'y',
					enable: true
				}
			});
		});

		$('#person-modal').on('hidden.bs.modal', function (e) {
			$('.person-modal .modal-body .person').remove();
		})

        // handle tables in accordions
        $('.subpage .accordion .collapse').on('shown.bs.collapse', function () {
            updateTableSize();
            $(window).resize();
        });

        // accordion scroll animation
        $('.subpage .accordion.scroll-animation .collapse').on('shown.bs.collapse', function () {
            const positionTop = $(this).parent().offset().top; // - $('header').height();
            $('html, body').animate({
                scrollTop: positionTop
            }, 500);
        });

	    // responsive-image module zoomable feature
	    document.querySelectorAll('.module.responsive-image .image-container.zoomable .desktop-image').forEach((containerElement) => {
		    const popupContainer = document.createElement('div');
		    popupContainer.classList.add('popup-image-container');
		    const clonedImg = containerElement.parentElement.querySelector('.popup-image img').cloneNode(true);
		    clonedImg.classList.add('popup-image');
		    popupContainer.appendChild(clonedImg);

		    const removePopupContainer = () => {
			    $(popupContainer).fadeOut(() => {
				    popupContainer.remove();
			    });
		    };
		    popupContainer.addEventListener('click', removePopupContainer);

		    const mediaQuery = window.matchMedia('(min-width: 768px)');
		    mediaQuery.addEventListener('change', () => {
			    if (!mediaQuery.matches) {
				    removePopupContainer();
			    }
		    })
		    containerElement.querySelector('img').addEventListener('click', () => {
			    if (mediaQuery.matches) {
				    document.body.appendChild(popupContainer);
				    $(popupContainer).fadeIn();
			    }
		    })
	    });

        //Tooltipster

		// default tooltips
		$('.default-tooltipster').tooltipster({
			maxWidth: 290,
			contentAsHTML: true,
			interactive: true,
			functionPosition: function (instance, helper, position) {
				position.coord.left = helper.geo.origin.offset.left - 20;
				return position;
			},
		});

	});
}(jQuery));
